import { render, staticRenderFns } from "./FixLocations.vue?vue&type=template&id=159f21d8&"
import script from "./FixLocations.vue?vue&type=script&lang=js&"
export * from "./FixLocations.vue?vue&type=script&lang=js&"
import style0 from "./FixLocations.vue?vue&type=style&index=0&id=159f21d8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports